import { auth } from './auth'
import { betHistory } from './betHistory'
import { bonuses } from './bonuses'
import { common } from './common'
import { errorStatusMessage } from './errorStatusMessage'
import { lastWins } from './lastWins'
import { payment } from './payment'
import { profile } from './profile'
import { promocode } from './promocode'
import { pwa } from './pwa'
import { slots } from './slots'
import { termsConditions } from './termsConditions'
import { wheelGame } from './wheelGame'

export const locale = {
  auth,
  common,
  profile,
  payment,
  betHistory,
  slots,
  promocode,
  errorStatusMessage,
  bonuses,
  wheelGame,
  termsConditions,
  pwa,
  lastWins,
}

export type engLocaleType = typeof locale
